/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SplitBillOfMaterialRowEntry } from '../../models/split-bill-of-material-row-entry';

export interface SplitBillOfMaterialRow$Params {
  productionOrderId: number;
      body: SplitBillOfMaterialRowEntry
}

export function splitBillOfMaterialRow(http: HttpClient, rootUrl: string, params: SplitBillOfMaterialRow$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, splitBillOfMaterialRow.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

splitBillOfMaterialRow.PATH = '/api/v1/ProductionOrder/{productionOrderId}/SplitBillOfMaterialRow';
